<template>
  <div class="suppliers">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <SuppliersTable
      :canCreate="canCreateSupplier"
      @create-supplier="onCreateSupplier"
      @edit-supplier="onEditSupplier"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs';
import SuppliersTable from '@/components/Suppliers/SuppliersTable';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { SUPPLIERS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'Suppliers',
  components: {
    Breadcrumbs,
    SuppliersTable,
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    canCreateSupplier() {
      return coversAccessLevel(this.getAccessLevel(SUPPLIERS_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('all_suppliers') }];
    },
  },
  methods: {
    onCreateSupplier() {
      this.$router.push({ name: 'SupplierCreatePage' });
    },
    onEditSupplier(supplier) {
      this.$router.push({
        name: 'SupplierEditPage',
        params: { supplierNumber: supplier.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
